import * as THREE from "three";
function cutTrailingZeros(s) {
    return s.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
}
export default class Vertex {
    #id;
    #vector;
    constructor(id, data) {
        this.#id = id;
        this.#vector = new THREE.Vector4(data[0], data[1], data[2], data[3] ?? 1);
    }
    get id() {
        return this.#id;
    }
    get x() {
        return this.#vector.x;
    }
    get y() {
        return this.#vector.y;
    }
    get z() {
        return this.#vector.z;
    }
    get w() {
        return this.#vector.w;
    }
    getData() {
        return this.#vector.toArray();
    }
    distanceTo(other) {
        const n0 = Math.abs(this.#vector.w);
        if (n0 < 1e-6) {
            return Infinity;
        }
        const n1 = Math.abs(other.#vector.w);
        if (n1 < 1e-6) {
            return Infinity;
        }
        const v0 = new THREE.Vector3().copy(this.#vector).divideScalar(n0);
        const v1 = new THREE.Vector3().copy(other.#vector).divideScalar(n1);
        return v0.distanceTo(v1);
    }
    toAffine() {
        const n = Math.abs(this.#vector.w);
        if (n < 1e-6) {
            throw new Error("Cannot convert to affine point");
        }
        return new THREE.Vector3(this.x / n, this.y / n, this.z / n);
    }
    toString() {
        const n = Math.abs(this.#vector.w);
        if (n < 1e-6) {
            return `[${this.#vector
                .toArray()
                .map((x) => x.toFixed(3))
                .map(cutTrailingZeros)
                .join(":")}]`;
        }
        const coords = this.#vector
            .toArray()
            .map((x) => (x / n).toFixed(3))
            .map(cutTrailingZeros)
            .slice(0, 3);
        if (this.w < 0) {
            return `-(${coords.join(",")})`;
        }
        return `+(${coords.join(",")})`;
    }
}
//# sourceMappingURL=Vertex.js.map